@if (error) {
  <nk-error-alert [error]="error"></nk-error-alert>
}

@if (companyFraudRiskScoreState$ | async; as state) {
  @if (state.loading) {
    <nk-company-analysis-risk-loading
      [text]="'fraud_risk_score.risk_score_loading' | translate"></nk-company-analysis-risk-loading>
  } @else {
    @if (state.data; as companyFraudRiskScore) {
      <nk-company-analysis-risk-layout
        [bgColor]="companyFraudRiskScoreColor[companyFraudRiskScore.fraud_risk_level]"
        [printVersion]="printVersion()"
        [attr.data-cy]="'company-analysis-fraud-risk-score'">
        <div class="d-flex align-items-top justify-content-between w-100" header>
          <div>
            <h1 class="mb-0" [attr.data-cy]="'company-analysis-fraud-risk-score-value'">
              {{ companyFraudRiskScore.fraud_risk_score }}
              <nk-risk-level-icon
                [attr.data-cy]="'company-analysis-fraud-risk-score-icon'"
                [riskLevel]="companyFraudRiskScore.fraud_risk_level"
                class="d-inline-block ms-1 fs-2"></nk-risk-level-icon>
            </h1>
            <p class="mb-0">
              {{ companyFraudRiskScoreTranslations[companyFraudRiskScore.fraud_risk_level] | translate }}
            </p>
          </div>
        </div>
        <div body>
          <p class="text-muted text-uppercase">
            {{ 'fraud_risk_score.components.title' | translate }}
          </p>
          <ul class="list-group list-group-flush" [attr.data-cy]="'company-analysis-fraud-risk-components'">
            @for (fraudRiskComponent of companyFraudRiskScore.fraud_risk_components; track $index) {
              <li class="list-group-item ps-0 pe-0 d-flex justify-content-between align-items-center">
                {{
                  'fraud_risk.component_key.' + fraudRiskComponent.component_key
                    | translateFallback: ('common.other' | translate)
                }}
                <span
                  class="badge text-bg-{{ fraudRiskComponent.component_score | fraudScoreRiskColorClass }} rounded-pill">
                  {{ fraudRiskComponent.component_score }}
                </span>
              </li>
            }
          </ul>
          @if (companyFraudRiskScore.fraud_risk_components.length === 0) {
            <p>{{ 'fraud_risk_score.components.no_components' | translate }}</p>
          }
        </div>
      </nk-company-analysis-risk-layout>
    } @else {
      <nk-company-analysis-risk-layout bgColor="gray" [printVersion]="printVersion()" [attr.data-cy]="'company-analysis-fraud-risk-score'">
        <div class="d-flex align-items-top justify-content-between w-100" header>
          <div>
            <h1 class="mb-0" [attr.data-cy]="'company-analysis-fraud-risk-score-value'">
              {{ 'common.unknown' | translate }}
              <nk-risk-level-icon
                [attr.data-cy]="'company-analysis-fraud-risk-score-icon'"
                [riskLevel]="'none'"
                class="d-inline-block ms-1 fs-2"></nk-risk-level-icon>
            </h1>
            <p class="mb-0">-</p>
          </div>
        </div>
        <div body>
          <p>{{ 'fraud_risk_score.risk_score_not_available' | translate }}</p>
        </div>
      </nk-company-analysis-risk-layout>
    }
  }
}
